﻿<template>
    <div>
        <div class="flex flex-col lg:flex-row gap-4 items-start mb-4">
            <div class="flex-1">
                <h3 class="tourTitle text-left mt-0 mb-2">{{getGroupName()}}</h3>
                <p class="text-sm mt-0 mb-0">{{getDescription()}}</p>
            </div>
            <img
                v-if="product?.marketing_information?.media[0]?.assets[0]?.asset_url"
                class="rounded shrink-0 h-32 w-48 object-cover hidden lg:block"
                :src="product.marketing_information.media[0].assets[0].asset_url + '?anchor=center&mode=crop&width=300&height=200'"
                :alt="imageAltText() || ''"
            >
        </div>
        <button v-if="!isAgent_Login() && GetBookingNotes() != ''" class="px-5 border-grey-default bg-form border-blank button text-black full" :disabled="true">{{GetBookingNotes()}}</button>
    </div>
</template>

<script lang="ts" src="./tour_heading.ts"></script>